import React, {useContext} from 'react'  
import ReturnContext from '../../../../context/ReturnsContext'
import ReactPaginate from 'react-paginate' 
 

const ReturnsPagination = () => {    

    let {totalItems, limit, setPage, searchParams, setSearchParams} = useContext(ReturnContext)  
   
    function handlePageClick(event){ 
        setPage(old => event.selected + 1 )  
        searchParams.set('page', event.selected + 1) 
        setSearchParams(searchParams.toString()) 
    }

    return (
        <> 
            <ReactPaginate
                breakLabel="..."
                nextLabel=" "
                onPageChange={handlePageClick} 
                pageCount={totalItems/limit}
                previousLabel=""
                selectedPageRel="a" 
                renderOnZeroPageCount={null}
                containerClassName="pagi"
                pageClassName="pagi-item"
                activeClassName="active"
                activeLinkClassName = "asd"
                nextClassName="next feather icon-chevron-right"
                previousClassName="prev feather icon-chevron-left" 
                forcePage={searchParams.get('page') ? searchParams.get('page') -1 : 0}
            />
        </>
    )
}

export default ReturnsPagination